import React from 'react'
import { Company } from '../../screens/Home/styles'
import Text from '../Text'

interface Props {
	url: string,
	image: string,
	company: string
}

const CompanyCard: React.FC<Props> = ({ url = '', image = '', company = '' }) => {
	return (
		<div
			style={{ height: 'auto', width: 'auto', marginLeft: '0px', margin: '20px', flexDirection: 'column', alignItems: 'center' }}
		>
			<div
				style={{ height: '144px', width: '144px' }}
			>
				<Company>
					<a style={{ height: '132px' }} href={url} target="_blank" rel="noopener noreferrer">
						<img src={image} alt={company} />
					</a>
				</Company>
			</div>
			<Text
				tag="h2"
				color="darkGray"
			>
				{company}
			</Text>
		</div>
	)
}

export default CompanyCard